/* AUTEUR PDP, strata. Scroll drives the playhead.

   The section pins for the length of its track, and scroll position inside that
   track sets video.currentTime. Six copy steps swap as their label lands in the
   film, so the picture and the reading column stay in step.

   WHY THE FILM IS ENCODED THE WAY IT IS:
   Seeking only lands on a keyframe. A normal export keyframes every couple of
   seconds, so scrubbing snaps between a handful of stills and looks broken. The
   source is re-encoded with a keyframe every third frame, and with the moov atom
   at the front so the first byte range is useful. That is why the file is heavier
   than a play-through version and why it must not be re-exported with defaults.

   WHY LOADING WAITS FOR VISIBILITY:
   A browser will not decode media in a tab it is not painting. A prerendered
   page, a cmd-clicked background tab or an automated check all sit at
   readyState 0 forever while networkState still says loading. An earlier version
   read that as failure and collapsed the section permanently, so a background
   tab the visitor later switched to was stuck with a still. Nothing starts now
   until the page is visible, the failure timer only runs while it is visible,
   and going static is reversible on the next visibility change.

   WHY THE COPY DOES NOT WAIT FOR THE FILM:
   The step highlighting and the progress rule are driven by scroll alone. Only
   the seek is gated on the video being decodable. An earlier version gated the
   whole update, so during the load window, and forever in any tab that never
   decodes, the reading column sat empty next to a poster. The words are the
   argument; they do not get to depend on a video file arriving.

   WHAT HAPPENS WHEN THIS GENUINELY CANNOT WORK:
   No JS, reduced motion, a decode error: the section falls to .is-static, the
   poster shows the finished diagram, and the six steps become a plain ruled
   list. The markup is authored that way from the start rather than degraded
   into it.

   Throttling is clock-based, not rAF, which is suspended in an unpainted tab. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var roots = document.querySelectorAll('[data-strata]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  });

  function init(root) {
    var track = root.querySelector('[data-track]');
    var pin = root.querySelector('[data-pin]');
    var video = root.querySelector('[data-video]');
    var list = root.querySelector('[data-steps]');
    var bar = root.querySelector('[data-bar]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-at]'));
    if (!track || !pin || !steps.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setStatic(on) {
      root.classList.toggle('is-static', on);
      if (list) list.classList.toggle('is-static', on);
    }

    var live = false, duration = 0, started = false, failTimer = null, dead = false;
    var last = 0, lastT = -1, lastStep = -1;

    function progress() {
      var runway = track.offsetHeight - pin.offsetHeight;
      if (runway <= 0) return 0;
      var p = (-track.getBoundingClientRect().top) / runway;
      return p < 0 ? 0 : (p > 1 ? 1 : p);
    }

    function update(force) {
      var now = +new Date();
      if (!force && now - last < 60) return;
      last = now;

      var p = progress();

      /* copy and progress rule: scroll only, never gated on the film */
      var idx = -1;
      for (var i = 0; i < steps.length; i++) {
        if (p >= parseFloat(steps[i].getAttribute('data-at'))) idx = i;
      }
      if (idx !== lastStep) {
        lastStep = idx;
        for (var j = 0; j < steps.length; j++) steps[j].classList.toggle('is-on', j === idx);
      }
      if (bar) bar.style.width = (p * 100).toFixed(1) + '%';

      /* the seek is the only part that needs a decodable video */
      if (!live || !duration) return;
      var t = p * duration;
      if (Math.abs(t - lastT) > 0.02) {
        lastT = t;
        try { video.currentTime = t; } catch (e) {}
      }
    }

    window.addEventListener('scroll', function () { update(false); }, true);
    window.addEventListener('resize', function () { update(true); });
    window.addEventListener('load', function () { update(true); });
    [200, 700, 1600].forEach(function (ms) { setTimeout(function () { update(true); }, ms); });
    update(true);

    if (!video || reduce) { setStatic(true); return; }

    var src = (window.innerWidth <= 900 ? video.getAttribute('data-src-sm') : video.getAttribute('data-src-lg'))
              || video.getAttribute('data-src-lg');
    if (!src) { setStatic(true); return; }

    video.setAttribute('playsinline', '');
    video.muted = true;

    function armFail() {
      clearTimeout(failTimer);
      failTimer = setTimeout(function () {
        if (!live && !document.hidden) setStatic(true);
      }, 10000);
    }

    function begin() {
      if (started || dead || document.hidden) return;
      started = true;
      video.preload = 'auto';
      video.src = src;
      try { video.load(); } catch (e) {}
      armFail();
    }

    video.addEventListener('loadedmetadata', function () {
      duration = video.duration || 0;
      if (!duration || !isFinite(duration)) { dead = true; setStatic(true); }
    });

    video.addEventListener('canplay', function () {
      if (live) return;
      live = true;
      clearTimeout(failTimer);
      setStatic(false);
      root.classList.add('is-live');
      try { video.currentTime = 0.001; } catch (e) {}
      update(true);
    });

    video.addEventListener('error', function () {
      dead = true;
      clearTimeout(failTimer);
      setStatic(true);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { clearTimeout(failTimer); return; }
      if (dead) return;
      if (!started) { begin(); return; }
      if (!live) { setStatic(false); armFail(); }
    });

    begin();
  }
})();
